var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49025 3.21462C1.36988 3.08661 1.20385 3.01129 1.02825 3.00505C0.852653 2.9988 0.68169 3.06213 0.552537 3.18127C0.423385 3.30041 0.346488 3.46571 0.338569 3.64124C0.330649 3.81677 0.392347 3.98833 0.510246 4.11862L2.91825 6.73128C3.27625 7.08195 3.80958 7.08195 4.14091 6.75128L4.38358 6.51195C5.25993 5.6501 6.13527 4.78721 7.00958 3.92328L7.03625 3.89662C7.85337 3.09133 8.66627 2.28176 9.47491 1.46795C9.59577 1.34142 9.66203 1.17244 9.65941 0.997481C9.65678 0.822522 9.58547 0.65561 9.46087 0.53276C9.33627 0.40991 9.16837 0.340972 8.99339 0.340821C8.81841 0.340669 8.65039 0.409317 8.52558 0.531951C7.72069 1.34151 6.91179 2.14707 6.09891 2.94862L6.07225 2.97528C5.23443 3.80348 4.39554 4.63059 3.55558 5.45662L1.49025 3.21462V3.21462Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f6b7967adb7e687dfe58076beec406b1.svg";
export { ForwardRef as ReactComponent };